import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { HeaderComponent } from "./components/HeaderComponent";
import { Hero } from './pages/Hero';
import { Work } from './pages/Work';
import { Education } from './pages/Education';
import { Skills } from './pages/Skills';
import { FooterComponent } from './components/FooterComponent';
import { Languages } from './pages/Languages';
import { SpotifyArtistsDiscovery } from './pages/SpotifyArtistsDiscovery';

function Home() {
  return (
    <div className="App">
      <HeaderComponent/>
      <Hero/>
      <Work/>
      <Education/>
      <Skills/>
      <Languages/>
      <FooterComponent/>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/spotify-artists-discovery" element={<SpotifyArtistsDiscovery />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
